import { GET_CHATS } from '../actionTypes';

const initialState = {
  chats: []
};

const chatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHATS:
      return {
        ...state,
        chats: action.payload
      };
    default: {
      return state;
    }
  }
};

export default chatsReducer;
